module.exports = __webpack_public_path__ + "static/media/one-tick-upsell.cc57cd06.png";